export default __webpack_public_path__ + "static/media/image-main-2-m@3x.5c93c624.webp";